/**
 * TealiumTrack Util
 * @class
 * @description Tealium utility for tracking events
 * @link https://docs.tealium.com/platforms/javascript/api
 */
export default class TealiumTrack {
  /**
   * @description Tracks non-page views, page interactions, and other dynamic page events.
   * @param {Object} props A data object containing the data layer variables associated with the event.
   */
  static link(props = {}) {
    window?.utag?.link(props);
  }
  // Note: we can include the view() or track() methods if needed, see api docs.
}

